export default "__VITE_ASSET__208ef08c__"